import { ReactComponent as IconClose } from '@/assets/svgs/icon-close.svg';
import { ReactComponent as IconFolder } from "@/assets/svgs/package-folder-icon.svg";
import Button from '@/components/Button/index';
import CardConfigure from '@/componentsDS/Modal/CardConfigure';
import Modal from '@/componentsDS/Modal/Modal';
import { ToastContext } from '@/context/toast/index';
import rem from '@/utils/rem';
import { useContext, useEffect, useState } from 'react';
import api from "@/services/api/packageFolder.js";

export default function RenamePackageFolderModal({ visible, close, data }) {
	const { addToastMessage } = useContext(ToastContext);

	const [name, setName] = useState(data?.name)
	const [errorMessage, setErrorMessage] = useState('')
	const [loading, setLoading] = useState(false)

	const validateFolderName = (name) => {
		let regex = /^[\w\-\s]+$/
		setErrorMessage(
			regex.test(name)
				? ''
				: 'Please re-enter the text. Input field allow only Alphanumeric, Hyphen or Space as characters.',
		)
	}

	const handleRenameFolderSubmit = async () => {
		setLoading(true);

		const [error] = await api.renameFolder(data?.id, { folderName: name });

		setLoading(false);

		if (error) {
			close()
			return addToastMessage('Failed to renamed folder', 'error')
		}

		document.getElementById('reload-eclips')?.click();
		close()
		addToastMessage('You have successfully renamed the Package folder.', 'success')
	}

	function handleClose() {
		setName(data?.name)
		setErrorMessage('')
		close()
	}

	useEffect(() => {
		setName(data?.name)
	}, [data])


	return (
		<Modal visible={visible} variant='medium' close={handleClose}>
			<CardConfigure>
				<CardConfigure.Header>
					<CardConfigure.Header.Title>
						<div className="card-configure__header__left">
							<div className="card-configure__title">
								<div className="card-configure__title__left">
									<div className={'card-configure__icon--package'}>
										<IconFolder />
									</div>
								</div>
								<div className="card-configure__title__right">
									<div className="card-configure__title__right__top">
										Rename Folder
									</div>
								</div>
							</div>
						</div>
					</CardConfigure.Header.Title>
				</CardConfigure.Header>
				<CardConfigure.Body>
					<CardConfigure.Body.Col>
						<span className="eclip-landing-filter--sublabel eclip-landing__create-folder--span">
							Name of Folder
						</span>
						<input
							type="text" value={name}
							onChange={(e) => {
								setName(e.target.value)
								validateFolderName(e.target.value)
							}}
							maxLength={42}
							placeholder="Name of Folder"
						/>
						{errorMessage && name !== '' && (
							<span className="error error-text">{errorMessage}</span>
						)}
					</CardConfigure.Body.Col>
				</CardConfigure.Body>
				<CardConfigure.Footer>
					<CardConfigure.Footer.Right>
						<Button ghost text="Cancel" submit={handleClose} />
						<span style={{ width: rem(10), display: 'inline-block' }}></span>
						<Button
							text="Confirm"
							loading={loading}
							disabled={loading || name === '' || errorMessage !== ''}
							submit={handleRenameFolderSubmit}
						/>
					</CardConfigure.Footer.Right>
				</CardConfigure.Footer>
			</CardConfigure>
		</Modal>
	)
}
